import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-show-chart-button',
    templateUrl: './show-chart-button.component.html',
    styleUrls: ['./show-chart-button.component.css'],
    standalone: false
})
export class ShowChartButtonComponent implements ICellRendererAngularComp {

  @Input() params: any;

  @Input() set data(val: any) {
    this.agInit({ data: val, value: val });
  }

  constructor(
  ) { }

  agInit(params: any): void {
    if (!params) return;
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

}
